export default __webpack_public_path__ + "static/media/promo-banner-transak.b8472a4e.svg";